import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { formatDateTime, toLocalePrice } from '../../../utils/StringUtil';
/**
 * ShareHistoryTable Component
 * 
 * Displays a table of share price history records.
 * Handles the display of record details and action buttons.
 * @param {Object} props - Component props
 * @param {Array} props.shareUpdateHistoryList - List of share price history records
 * @param {Function} props.onDelete - Callback when delete is clicked for a record
 * @param {Function} props.onEdit - Callback when edit is clicked for a record
 */
const ShareHistoryTable = ({ shareUpdateHistoryList, onDelete, onEdit }) => {
    return (
        <table className="table table-striped table-borderless w-100 p-0 m-0">
            <thead>
                <tr className="fs-normal-semibold text-center">
                    <th scope="col">
                        <p className="mb-2">Valuation Date</p>
                    </th>
                    <th scope="col">
                        <p className="mb-2">Remark</p>
                    </th>
                    <th scope="col">
                        <p className="mb-2 text-end">Unit Value</p>
                    </th>
                    <th scope="col">
                        <p className="mb-2 text-end">Multiple</p>
                    </th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                {shareUpdateHistoryList.map((data) => (
                    <tr className="fs-normal-medium text-center" key={data.spuRid}>
                        <td className="pt-3">{formatDateTime(data.date, false)}</td>
                        <td className="pt-3">{data.remarks || "---"}</td>
                        <td className="pt-3 text-end">{toLocalePrice(data.unitValue)}</td>
                        <td className="pt-3 text-end">
                            {data.multiple ? `${data.multiple}x` : "---"}
                        </td>
                        <td className="pt-0 text-center">
                            <div className="d-flex justify-content-center">
                                {/* {onEdit && (
                                    <IconButton color="primary" onClick={() => onEdit(data)}>
                                        <EditIcon />
                                    </IconButton>
                                )} */}
                                <IconButton color="error" onClick={() => onDelete(data.spuRid)}>
                                    <DeleteOutlineIcon />
                                </IconButton>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
ShareHistoryTable.propTypes = {
    shareUpdateHistoryList: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func
};

export default ShareHistoryTable;